<template>
    <el-popover ref="popover" :placement="placement" :popper-class="`my_el_popover_${page}`" trigger="click">
        <div class="my_el_popover_con">
            <img src="@i/exercise/tips.svg" alt="">
            <ul class="hint_img">
                <li>
                    <div>
                        <img src="@i/exercise/pass.svg" alt />
                    </div>

                    <span>{{ $t("exercise.传球/打门") }}</span>
                </li>
                <li>
                    <div>
                        <img src="@i/exercise/move.svg" alt />
                    </div>

                    <span>{{ $t("exercise.移动") }}</span>
                </li>
                <li>
                    <div>
                        <img src="@i/exercise/dribbling.svg" alt />
                    </div>

                    <span>{{ $t("exercise.带球") }}</span>
                </li>
                <li>
                    <div>
                        <img src="@i/exercise/interception.svg" alt />
                    </div>

                    <span>{{ $t("exercise.拦截") }}</span>
                </li>
            </ul>
        </div>
        <span slot="reference">
            <slot><img src="@i/exercise/subtract.svg" alt class="hint" /></slot>
        </span>
    </el-popover>
</template>

<script>
    /**
    * Filename: 教案详情 tip
    * Created Date: 2022/6/9
    Creator: Nancy
    * 组件说明：
    * @param page 传页面标识，根据不同页面修改不同样式
    * eg:
    *     <cl-hint></cl-hint>
    */
    export default {
        name: 'cl-hint',
        props: {
            placement: {
                type: String,
                default: 'right-start'
            },
            page: {
                type: String,
                default: ''
            }
        }
    };
</script>

<style lang="scss">
    .my_el_popover_ {
        margin-top: -5px;
        width: 135px;
        height: 166px;
        background: #FBFDFF !important;
        border-radius: 6px;
        padding: 0px !important;
        box-sizing: border-box;

        .popper__arrow {
            width: 16px;
            height: 16px;
            background: #FBFDFF !important;
            border-radius: 3px;
            padding: 0;
            border: 0;
            transform: rotate(45deg);
            left: 108px !important;
            bottom: -5px !important;
        }

        .popper__arrow::after {
            width: 0;
            height: 0;
            margin: 0;
            padding: 0;
            border: 0;
        }

        .my_el_popover_con {
            &>img {
                margin: 8px 0 0 8px;
                position: relative;
                z-index: 3;
            }
        }

        .hint_img {
            padding-left: 24px;
            display: flex;
            justify-content: space-around;
            flex-direction: column;
            font-size: 14px;

            li {
                display: flex;
                align-items: center;
                margin-bottom: 16px;

                div {
                    min-width: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                span {
                    font-size: 12px;
                    line-height: 17px;
                    color: #3A3A3A;
                    opacity: .8;
                    margin-left: 16px;
                }
            }
        }

        .hint {
            width: 22px;
            height: 22px;
            cursor: pointer;
        }
    }
    .my_el_popover_schedule {
        @extend .my_el_popover_;
        margin-right: 9px;
    }
</style>
